<template>
  <div class="app-field" :class="{ 'app-field--error': hasError, 'app-field--disabled': disabled }">
    <textarea
      v-if="textarea"
      :id="inputId"
      ref="input"
      class="app-input app-input--textarea"
      :value="value"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :autocomplete="autocomplete"
      :aria-invalid="hasError ? 'true' : null"
      :aria-describedby="describedBy"
      v-bind="$attrs"
      v-on="listeners"
    ></textarea>
    <input
      v-else
      :id="inputId"
      ref="input"
      class="app-input"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :autocomplete="autocomplete"
      :aria-invalid="hasError ? 'true' : null"
      :aria-describedby="describedBy"
      v-bind="$attrs"
      v-on="listeners"
    />
    <p v-if="errorText" :id="errorId" class="app-field__error">
      <app-icon name="alert" :size="14" />{{ errorText }}
    </p>
  </div>
</template>

<script>
// Eingabefeld (Spezifikation 2.6) mit nativem <input>/<textarea>: Höhe 32/44, Rahmen rundum --field-edge mit Schatten --sh-ctl,
// Eingabetext 13/16 px. error = Meldungstext (oder true nur für die rote Unterkante; eine Meldung daneben dann über
// aria-describedby verbinden). Labels stehen in Formularen über dem Feld:
// <label class="app-label" :for="id">…</label><app-text-field :id="id" v-model="…" />
import AppIcon from './AppIcon.vue';

export default {
  name: 'AppTextField',
  components: { AppIcon },
  inheritAttrs: false,
  props: {
    value: { type: [String, Number], default: '' },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: null },
    textarea: { type: Boolean, default: false },
    rows: { type: [Number, String], default: 2 },
    id: { type: String, default: null },
    error: { type: [String, Boolean], default: null },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    autocomplete: { type: String, default: null }
  },
  computed: {
    inputId() {
      return this.id || 'app-field-' + this._uid;
    },
    errorId() {
      return this.inputId + '-fehler';
    },
    hasError() {
      return !!this.error;
    },
    errorText() {
      return typeof this.error === 'string' ? this.error : '';
    },
    // eigene Meldung und eine Beschreibung von außen (aria-describedby, z. B. eine gemeinsame Meldung zweier Felder):
    // die ausdrückliche Bindung hätte die von außen sonst verdrängt
    describedBy() {
      const ids = [this.errorText ? this.errorId : null, this.$attrs['aria-describedby'] || null].filter(Boolean);
      return ids.length ? ids.join(' ') : null;
    },
    listeners() {
      return Object.assign({}, this.$listeners, {
        input: (e) => this.$emit('input', e.target.value)
      });
    }
  },
  methods: {
    focus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    }
  }
};
</script>
